'use client';

import {
  Select,
  type SelectProps,
} from '@ironhack/design-system2/components/select';
import { useSearchParams } from 'next/navigation';
import { type ChangeEvent, type ReactElement, useState } from 'react';

type Props = {
  options: Array<{ code: string; name: string }>;
} & SelectProps;

type FilteredProps = {
  paramName: string;
} & Props;

export const FilterSelect = (props: Props): ReactElement => {
  const { options, ...selectProps } = props;

  return (
    <Select {...selectProps}>
      {options.map(({ name, code }) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </Select>
  );
};

export const FilterSelectStateful = (props: FilteredProps): ReactElement => {
  const { onChange: propOnChange, paramName, ...selectProps } = props;
  const searchParams = useSearchParams();
  const searchValue = searchParams?.get(paramName);

  // Keep small internal state for when the user selects the placeholder
  const [value, setValue] = useState(searchValue ?? '');
  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    propOnChange?.(event);
  };

  return (
    <FilterSelect
      value={value}
      {...(propOnChange && { onChange })}
      {...selectProps}
    />
  );
};
